module.exports = __webpack_public_path__ + "img/page-32.b48d6bfd.jpg";